import { useAuthContext } from "../../AuthContext";
import { useContext } from "react";
import { WalletContext } from "../../component/Context/noteContext";

const SwitchNetwork = () => {
  console.log("name");
  const { setErrorState } = useAuthContext();
  const { setWalletConnection } = useContext(WalletContext);
  const polyNet = {
    chainId: `0x${Number(137).toString(16)}`,
    chainName: "Polygon Mainnet",
    nativeCurrency: {
      name: "MATIC",
      symbol: "MATIC",
      decimals: 18,
    },
    rpcUrls: ["https://polygon-rpc.com/"],
    blockExplorerUrls: ["https://polygonscan.com"],
  };
  const networkSwith = async (networkName) => {
    try {
      if (!window.ethereum) throw new Error("Wallet not found");
      await window.ethereum.request({
        method: "wallet_addEthereumChain",
        params: [
          {
            ...polyNet,
            networkName,
          },
        ],
      });
      setWalletConnection(true);
      setErrorState(false);
    } catch (error) {
      console.log("Meta error", error.message);
    }
  };
  return {
    networkSwith,
  };
};
export default SwitchNetwork;
